import { render, staticRenderFns } from "./WizardContentRadioSelector.vue?vue&type=template&id=aef4ca84&scoped=true&"
import script from "./WizardContentRadioSelector.vue?vue&type=script&lang=ts&"
export * from "./WizardContentRadioSelector.vue?vue&type=script&lang=ts&"
import style0 from "./WizardContentRadioSelector.vue?vue&type=style&index=0&id=aef4ca84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef4ca84",
  null
  
)

export default component.exports